/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { Telemetry };
class Telemetry {
    probe;
    path;
    index = 0;
    static create(context) {
        if (context.probe && context.invocationPath) {
            return new Telemetry(context.probe, context.invocationPath);
        }
        return undefined;
    }
    constructor(probe, path) {
        this.probe = probe;
        this.path = path;
    }
    async startModule() {
        await this.probe.report?.({
            type: "graphstart",
            data: {
                graph: virtualGraph(),
                graphId: "",
                path: this.path,
                timestamp: timestamp(),
            },
        });
    }
    async startCapability(type, inputs, metadata) {
        const path = ++this.index;
        await this.probe.report?.({
            type: "nodestart",
            data: {
                node: this.#getDescriptor(type, metadata),
                inputs,
                path: this.invocationPath(path),
                timestamp: timestamp(),
            },
        });
        return path;
    }
    async endCapability(type, path, inputs, outputs) {
        await this.probe.report?.({
            type: "nodeend",
            data: {
                node: this.#getDescriptor(type),
                inputs,
                outputs,
                path: this.invocationPath(path),
                timestamp: timestamp(),
                newOpportunities: [],
            },
        });
    }
    async endModule() {
        await this.probe.report?.({
            type: "graphend",
            data: {
                path: this.path,
                timestamp: timestamp(),
            },
        });
    }
    invocationPath(path) {
        return [...this.path, path];
    }
    #getDescriptor(type, metadata) {
        return {
            id: `${type}-${this.index}`,
            type,
            metadata,
        };
    }
}
function virtualGraph() {
    return {
        nodes: [],
        edges: [],
        virtual: true,
    };
}
function timestamp() {
    return globalThis.performance.now();
}
//# sourceMappingURL=telemetry.js.map